import PropTypes from "prop-types"
import React, { useEffect, useCallback, useState } from "react"

import withRouter from "../Common/withRouter"
import {
  changeLayout,
  changeSidebarTheme,
  changeLayoutMode,
  changeTopbarTheme,
  changeSidebarSize,
  changeLayoutWidth,
  showRightSidebarAction,
} from "../../store/actions"

import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import Rightbar from "../CommonForBoth/Rightbar"
import AskAIButton from "../AskAIButton/AskAIButton"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"


const Layout = props => {

  const dispatch = useDispatch()

  const selectLayoutState = state => state.Layout
  const selectLayoutProperties = createSelector(selectLayoutState, layout => ({
    isPreloader: layout.isPreloader,
    leftSideBarType: layout.leftSideBarType,
    layoutModeType: layout.layoutModeType,
    layoutWidth: layout.layoutWidth,
    topbarTheme: layout.topbarTheme,
    sidebarSizeType: layout.sidebarSizeType,
    showRightSidebar: layout.showRightSidebar,
    leftSideBarTheme: layout.leftSideBarTheme,
  }))

  const {
    isPreloader,
    leftSideBarType,
    layoutModeType,
    layoutWidth,
    topbarTheme,
    sidebarSizeType,
    showRightSidebar,
    leftSideBarTheme,
  } = useSelector(selectLayoutProperties)

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarSize("condensed", isMobile))
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarSize("default", isMobile))
    }
  }

  //hides right sidebar on body click
  const hideRightbar = useCallback(
    event => {
      const rightbar = document.getElementById("right-bar")
      const appRoot = document.querySelector(".ksr-root")
      const safeZone = document.getElementById("layout-click-safe-zone")

      const clickedInsideRightbar = rightbar?.contains(event.target)
      const clickedInsideApp = appRoot?.contains(event.target)
      const clickedInsideSafeZone = safeZone?.contains(event.target)

      if (clickedInsideRightbar || clickedInsideApp || clickedInsideSafeZone) {
        return
      }

      dispatch(showRightSidebarAction(false))
    },
    [dispatch]
  )

  /*
  layout  settings
  */

  const pathName = props.router.location.pathname

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar)

    // Hide preloader immediately - TopProgressBar handles loading indication
    const preloader = document.getElementById("preloader")
    const status = document.getElementById("status")
    if (preloader) preloader.style.display = "none"
    if (status) status.style.display = "none"

    return () => {
      document.body.removeEventListener("click", hideRightbar)
    }
  }, [hideRightbar, pathName])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    dispatch(changeLayout("vertical"))
  }, [dispatch])

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme))
    }
  }, [leftSideBarTheme, dispatch])
  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth))
    }
  }, [layoutWidth, dispatch])

  useEffect(() => {
    if (sidebarSizeType) {
      dispatch(changeSidebarSize(sidebarSizeType))
    }
  }, [sidebarSizeType, dispatch])

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType))
    }
  }, [layoutModeType, dispatch])

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme))
    }
  }, [topbarTheme, dispatch])



  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <i className="uil-shutter-alt spin-icon"></i>
          </div>
        </div>
      </div>
      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <div className="main-content">
          {props.children}
          <Footer />
        </div>
      </div>

      {/* Floating Ask AI button - available on all pages except AI CMO page */}
      {!pathName.startsWith("/ai-cmo") && <AskAIButton />}

      {showRightSidebar ? <Rightbar /> : null}
    </React.Fragment>
  )
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeLayoutMode: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarSize: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutModeType: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
}

export default withRouter(Layout)
